import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "json",
  "name": "JSON",
  "category": "utilities",
  "description": "Parse and generate JSON data",
  "icon": "Braces",
  "color": "gray",
  "version": "1.0.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "JSON",
    "color": "#6b7280"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "json",
    "parse",
    "stringify",
    "format"
  ]
};

export default definition;
